import { useQuery } from '@apollo/client';
import type { DocumentNode } from 'graphql';
import type { FindPalletTagsVariables } from 'types/graphql';
import type { PalletTagPickerData } from '../components/palletTagPickerVariants';

/**
 * The picker's on-demand lot read (the variant picks `FindPalletTags` or `FindPalletTagsWithLocation`).
 * Skipped on mount; `findPalletTags({ id })` sends the one request, and `variables` is the last lot asked for.
 */
export function useFindLotPalletTags(query: DocumentNode) {
  const { refetch, variables } = useQuery<PalletTagPickerData, FindPalletTagsVariables>(query, { skip: true });

  return { findPalletTags: refetch, variables };
}
